import classNames from "classnames";
import { Button } from "components/DesignSystem/Button/Button";
import ToolTip from "components/design/toolTip";
import { CaretDown } from "components/icons/CaretDown";
import { useState } from "react";
import { RequestedAnswerItem } from "types/Models/chatQnA";
import { pluralize } from "utils/pluralize";
import { AnsweredQuestionCard } from "./AnsweredQuestionCard";

export const AcceptedResponses = ({
  responses,
  startNumber = 1,
}: {
  responses: RequestedAnswerItem[];
  startNumber?: number;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  if (responses.length === 0) return null;

  const acceptedResponsesLabel = `${pluralize(
    responses.length,
    "accepted response",
    "accepted responses"
  )}`;

  return (
    <div className="t-flex t-flex-col t-gap-2">
      <ToolTip text="Click to view accepted responses" side="top">
        <Button
          type="button"
          customType="link_neutral"
          size="regular"
          className="!t-px-0 t-text-text-30"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <span>Show {acceptedResponsesLabel}</span>
          <span
            className={classNames("t-shrink-0 t-ml-1 t-transition-transform", {
              "-t-rotate-90": !isOpen,
            })}
          >
            <CaretDown width="10" height="10" />
          </span>
        </Button>
      </ToolTip>

      {isOpen && (
        <div className="t-flex t-flex-col t-gap-3">
          {responses.map((response, index) => (
            <AnsweredQuestionCard
              key={response.uuid}
              number={startNumber + index}
              response={response}
            />
          ))}
        </div>
      )}
    </div>
  );
};
